// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__223Kq","rootMobile":"styles_rootMobile__1NO1d"};